<sk-job-progress-details jobType="Restore" [metrics]="metrics" [isRefreshing]="isRefreshing" (reloadData)="onReloadData()"></sk-job-progress-details>
